var map = {
	"./avatars/avatar": 22,
	"./avatars/avatar-3": 23,
	"./avatars/avatar-3.png": 23,
	"./avatars/avatar.jpg": 22,
	"./errors-images/404-error": 24,
	"./errors-images/404-error.png": 24,
	"./errors-images/505-error": 25,
	"./errors-images/505-error.png": 25,
	"./lexiqamus-logo": 26,
	"./lexiqamus-logo.png": 26,
	"./logo-icon": 27,
	"./logo-icon.png": 27,
	"./lq-logo": 28,
	"./lq-logo.png": 28
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 101;